import * as React from "react"
import { SvgFunction } from '@web-libs/ui/svgs/types';
const MyAreaIcon: SvgFunction = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 32}
    height={props.height ??  32}
    viewBox={"0 0 32 32"}
  >
    <g clipPath="url(#a)">
      <path
        fill={props.fill}
        d="M29.313 7.565V2.64a1.334 1.334 0 0 0-2.666 0v3.115l-6.918-4.667a6.64 6.64 0 0 0-7.458 0L2.937 7.387A6.66 6.66 0 0 0 0 12.913v12.422A6.674 6.674 0 0 0 6.667 32h18.666A6.674 6.674 0 0 0 32 25.335V12.913c0-2.116-1-4.092-2.687-5.348ZM10.667 29.333A5.339 5.339 0 0 1 16 24a5.339 5.339 0 0 1 5.333 5.333H10.667Zm18.666-4c0 2.206-1.794 4-4 4H24c0-4.412-3.588-8-8-8s-8 3.588-8 8H6.667c-2.206 0-4-1.794-4-4V12.912a3.99 3.99 0 0 1 1.762-3.315L13.763 3.3A3.99 3.99 0 0 1 16 2.61c.779 0 1.557.229 2.237.688l9.334 6.298a3.994 3.994 0 0 1 1.762 3.315v12.421ZM16 9.333a5.339 5.339 0 0 0-5.333 5.334A5.339 5.339 0 0 0 16 20a5.339 5.339 0 0 0 5.333-5.333A5.339 5.339 0 0 0 16 9.333Zm0 8a2.67 2.67 0 0 1-2.667-2.666A2.67 2.67 0 0 1 16 12a2.67 2.67 0 0 1 2.667 2.667A2.67 2.67 0 0 1 16 17.333Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default MyAreaIcon
